module.exports = __webpack_public_path__ + "img/ms_b2_pic2.fed3b454.png";